import { Component, Input, OnInit } from "@angular/core";
import { SedsSizeOptions } from "experian-design-system"; // NOSONAR

@Component({
    selector: "pl-error-load-user-info",
    templateUrl: "./error-load-user-info.component.html",
    styleUrls: ["./error-load-user-info.component.scss"],
    standalone: false
})
export class ErrorLoadUserInfoComponent implements OnInit {
  public smallButton = SedsSizeOptions.SMALL;

  @Input() messageType!: "BLOCK_USER" | "DELETE_USER" | "UNBLOCK_USER" | "RESET";

  public errorTitle = "";

  private readonly _TITLE_BY_MESSAGE_TYPE: { [key: string]: string } = {
    DELETE_USER: "Não foi possível prosseguir com a exclusão do usuário",
    BLOCK_USER: "Não foi possível prosseguir com o bloqueio do usuário",
    UNBLOCK_USER: "Não foi possível prosseguir com o desbloqueio do usuário",
    RESET: "Não foi possível prosseguir com a redefinição da senha do usuário",
  };

  ngOnInit(): void {
    this.errorTitle = this._TITLE_BY_MESSAGE_TYPE[this.messageType] || "";
  }
}
